import { useParams } from "react-router-dom";
import NoMatch from "./404";

const CommonGuard = ({ children, allowedTypes = [], requireIdFor = [] }) => {
  const { type, id } = useParams();

  if (allowedTypes.length && !allowedTypes.includes(type)) {
    return <NoMatch />;
  }

  if (requireIdFor.includes(type)) {
    if (!id || Number(id) <= 0) {
      return <NoMatch />;
    }
  }

  return children;
};

export default CommonGuard;
